import { urlBaseAccreditation } from "../../config/";
import axiosInstance from "../../../services/config/axiosinstance";

export default async function getScheduleGuestsCount(
  eventId = '',
  scheduleId = '',
  group = '',
  isRestrict = false,
) {
  try {
    const _config = {
      method: 'GET',
      url: `${urlBaseAccreditation}/report/getScheduleGuestsCount?eventId=${eventId}&scheduleId=${scheduleId}&group=${group}&isRestrict=${isRestrict}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return _ret.data.data;
  } catch (error) {
    console.log('Error getScheduleGuestsCount', error);
    throw error;
  }
}
